<section class="testimonials-area ptb-100">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <h2>{{sectionTitleContent.title}}</h2>
        <p>{{sectionTitleContent.paragraphText}}</p>
      </div>
    }

    <div class="testimonials-slides owl-carousel owl-theme">
      @for (TestimonialsBoxContent of singleTestimonialsBox; track TestimonialsBoxContent) {
        <div class="single-testimonials-box bg-fafafb">
          <img [src]="TestimonialsBoxContent.clientImg" class="shadow-sm" [alt]="TestimonialsBoxContent.clientName">
          <p>{{TestimonialsBoxContent.paragraphText}}</p>
          <div class="client-info">
            <h3>{{TestimonialsBoxContent.clientName}}</h3>
            <span>{{TestimonialsBoxContent.clientDesignation}}</span>
          </div>
        </div>
      }
    </div>

    @for (Btn of testimonialsBtn; track Btn) {
      <div class="testimonials-view-btn text-center">
        <a routerLink="/{{Btn.link}}" class="default-btn"><i class="{{Btn.icon}}"></i>{{Btn.text}}<span></span></a>
      </div>
    }
  </div>

  <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
</section>